declare const __BUILD_ID__: string;

// Paths where an automatic reload could interrupt a student mid-exam.
const UNSAFE = /^\/exam\/(take|written\/take)/;
const INTERVAL_MS = 5 * 60 * 1000;

let pendingReload = false;

async function check() {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return;
    const { id } = await res.json();
    if (id && id !== __BUILD_ID__) {
      pendingReload = true;
      tryReload();
    }
  } catch {
    /* offline — try later */
  }
}

function tryReload() {
  if (!pendingReload || UNSAFE.test(window.location.pathname)) return;
  window.location.reload();
}

export function startUpdateChecker() {
  if (!import.meta.env.PROD || typeof window === 'undefined') return;
  setInterval(check, INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
  window.addEventListener('focus', check);
  // Reload on the next page change once the student leaves an exam.
  window.addEventListener('popstate', tryReload);
  const origPush = history.pushState;
  history.pushState = function (...args) {
    origPush.apply(this, args as any);
    setTimeout(tryReload, 0);
  };
}
